module.exports = require("win-ca");